module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.author) ? _c('div', {
    staticClass: "author-detail"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "author-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v(_vm._s(_vm.author.firstName) + " " + _vm._s(_vm.author.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v(_vm._s(_vm.authorInfo.filter(Boolean).join(' / ')))])]), _vm._v(" "), _c('div', {
    staticClass: "row hidden-sm-up"
  }, [_c('div', {
    staticClass: "col p-0"
  }, [_c('social-media-buttons', {
    staticClass: "social-media-buttons m-0",
    attrs: {
      "media-links": _vm.author.mediaLinks
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('a', {
    staticClass: "envelope",
    attrs: {
      "href": ("mailto:" + (_vm.author.email))
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope-o"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-12 mb-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.getStaticPath(_vm.author.photoUrl ? 'img/temp/' + _vm.author.photoUrl : '')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n        " + _vm._s(_vm.author.description) + "\n        "), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-down"
  }, [_c('social-media-buttons', {
    staticClass: "social-media-buttons",
    attrs: {
      "media-links": _vm.author.mediaLinks
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button-primary",
    attrs: {
      "href": ("mailto:" + (_vm.author.email))
    }
  }, [_vm._v("Email Board author >")]), _vm._v(" "), _c('a', {
    staticClass: "button-primary"
  }, [_vm._v("Fields of Interest >")])], 1)])])]), _vm._v(" "), _c('title-block', {
    attrs: {
      "id": 'authorsIssues',
      "title": (_vm.siteName + " Papers from this Author"),
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.authorsIssues), function(paper) {
    return _c('condensed-issue', {
      key: paper.id,
      attrs: {
        "issue": paper
      }
    })
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "id": 'top100Papers',
      "title": "Top 100 Papers from the Editorial Board",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.top100Papers), function(paper) {
    return _c('condensed-issue', {
      key: paper.id,
      attrs: {
        "issue": paper
      }
    })
  }))])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea54fe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AuthorDetailsComponent.vue
// module id = 1421
// module chunks = 1